export const SORT_DIRECTION_ASC = "ASC";
export const SORT_DIRECTION_DESC = "DESC";

export const formatDriverName = (driverFirstName: string, driverLastName: string): string => {
  return `${driverFirstName || ''} ${driverLastName || ''}`.trim();
}